import React from 'react';
import { validDate } from '../../../services/validators.service';
import Input from '../../Input';

export default function BirthDay(props) {
    return <Input validators={[validDate()]} {...props}></Input>;
}
